module.exports = __webpack_public_path__ + "img/1970East-045_WEB-min.64ddb634.jpg";